import { createFileRoute, redirect } from "@tanstack/react-router";
import { getLastTradeSymbol } from "#/features/trade/stores/last-trade-symbol";

export const Route = createFileRoute("/_app/trade/")({
	beforeLoad: () => {
		const symbol = getLastTradeSymbol() ?? "BTC";
		throw redirect({
			to: "/trade/$symbol",
			params: { symbol },
			replace: true,
		});
	},
});
